import axios from 'axios';
import { authUrl } from '../utils/auth-header';
import BASEURL from '../utils/config';

const baseURL = `${BASEURL}/sessions`;

const getAllSessions = (
  limit,
  offset,
  order,
  searchQuery = '%',
  anonymousInclude,
  exactSearch,
  sessionType = null,
  sessionCompleted = null,
  sessionDecrease = null,
  startDate = null,
  clientId,
) => {
  const anonymous = anonymousInclude ? `&anonymous=${anonymousInclude}` : '';
  const session_type = sessionType ? `&session_type=${sessionType}` : '';
  const completed = sessionCompleted ? `&completed=${sessionCompleted}` : '';
  const decrease = sessionDecrease
    ? `&decrease_range=[${sessionDecrease}]`
    : '';
  const start_date = startDate ? `&start_date_range=${JSON.stringify(startDate)}` : '';
  const exact_search = exactSearch ? `&exact_search=${exactSearch}` : '';
  const client_id = clientId ? `&clientId=${clientId}` : '';
  const filterString = `&offset=${offset}&limit=${limit}&order=${order}&query=${encodeURIComponent(
    searchQuery,
  )}${anonymous}${session_type}${completed}${decrease}${start_date}${exact_search}${client_id}`;
  return axios.get(`${baseURL}/getWithSort${authUrl()}${filterString}`);
};

const getSessionsCount = (filter = '') =>
  axios.get(`${baseURL}/count${authUrl()}${filter}`);

const findSessionById = (sessionId) => {
  const filter = { include: ['therapist', 'organization', 'team', 'device'] };
  return axios.get(
    `${baseURL}/${sessionId}${authUrl()}&filter=${JSON.stringify(filter)}`,
    {},
  );
};

const updateSessionById = (sessionId, body) =>
  axios.patch(`${baseURL}/${sessionId}${authUrl()}`, body);

const deleteSessionById = (sessionId) =>
  axios.patch(`${baseURL}/${sessionId}${authUrl()}`, { is_deleted: true });

const getAllSessionsByTreatmentUUID = (treatmentUUID) =>
  axios
    .get(
      `${baseURL}?filter[where][treatmentUUID]=${treatmentUUID}${authUrl().replace(
        '?',
        '&',
      )}`,
    )
    .then((result) => result.data)
    .catch(() => []);

export const sessionService = {
  getAllSessions,
  findSessionById,
  getAllSessionsByTreatmentUUID,
  getSessionsCount,
  updateSessionById,
  deleteSessionById,
};
